module.exports = __webpack_public_path__ + "img/logo.c4e6aea7.png";